/**
 * V1.5 Reader-Mode Hook (Phase 11 → B5 Update).
 * Quelle: Brief §9 + plan-rechtemodell-blockB.md §B5.
 *
 * Betrachter = kein Admin UND keine Funktionsrolle.
 * Reader sieht alles, kann aber nichts schreiben. Edit-Buttons werden
 * disabled + bekommen Tooltip "Sie haben Leserechte".
 *
 * Capability-basiert (einachsiges Modell): kein role-Feld mehr.
 * Pro-Objekt-Gating läuft über die geteilte Matrix in lib/permissions.ts.
 */
import { createContext, useContext } from 'react';
import { useSession } from './session.js';

/**
 * #123: Ein zusammengeführtes Projekt ist für JEDEN nur lesbar — auch für Admins. Die
 * Projektdetail-Seite setzt diesen Kontext; alle Stellen, die `useReaderMode()` nutzen, sperren
 * sich damit ohne Einzeländerung. Der Server lehnt ohnehin mit 409 ab; hier geht es darum, dass
 * die Oberfläche nichts anbietet, was dann scheitert.
 */
export const NurLesbarContext = createContext(false);

/** #123: true im Projektdetail eines zusammengeführten Projekts (unabhängig von der Rolle). */
export function useNurLesbar(): boolean {
  return useContext(NurLesbarContext);
}

export function useReaderMode(): boolean {
  const nurLesbar = useContext(NurLesbarContext);
  const { user } = useSession();
  if (nurLesbar) return true;
  if (!user) return true;
  // Betrachter = weder Admin noch irgendeine Funktionsrolle
  return !user.is_admin && (user.function_roles?.length ?? 0) === 0;
}

export function useCanEdit(): boolean {
  return !useReaderMode();
}
